import React from "react";

export const Tag = ({ children, className = "", margin = "mr-4" }) => {
  if (!children) return null;
  return (
    <span
      className={`rounded-sm bg-yellow py-1.5 px-1 text-sm font-normal text-typo ${margin} ${className}`}
    >
      {children}
    </span>
  );
};
